import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'

export const useSafePush = () => {
  const [isUrlChanging, setIsUrlChanging] = useState(false)
  const router = useRouter()

  // safeUrlPush is used to avoid route pushing errors when users click multiple times, when code calls this multiple times,
  // or when the network is slow:  "Error: Abort fetching component for route"
  const safeUrlPush = useCallback(
    async (...params: Parameters<typeof router.push>) => {
      if (isUrlChanging) return
      setIsUrlChanging(true)
      await router.push(...params)
    },
    [isUrlChanging, router]
  )

  useEffect(() => {
    const handleRouteChange = () => {
      setIsUrlChanging(false)
    }

    const handleRouteChangeError = () => {
      setIsUrlChanging(false)
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    router.events.on('routeChangeError', handleRouteChangeError)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
      router.events.off('routeChangeError', handleRouteChangeError)
    }
  }, [router])
  return { safeUrlPush }
}
